export default {
	BLACK: "#000000",
	WHITE: "#FFFFFF",
	GRAY: "#6a737c",
	DARK_GRAY: "#242c34",
	BLUE: "#1576d6",
	LIGHT_GRAY: "#e4dede",
	LIGHT_BLUE: "#3a91e8",
	DARK_BLUE: "#005fbe",
	ORANGE: "#e98734",
	VERY_LIGHT_BLUE: "#1576d6",
	LIGHT_ORANGE: "#f5a855",
	LIGHT_RED: "#fff2f2",
	RED: "#b82533",
	DARK_RED: "#9b2b02",
	GREEN: "#177e58",
	WARNING_COLOR: "#ffa000",
	LIGHT_GREEN: "#f0fcf5",
	SHAINCOLOR: "#F7F8FA",
	BASECOLOR: "#F3F5F7",
	BORDER_BUTTON_COLOR: "#868e96",
	ERROR: "#e65d63",
	HIGHLIGHT_TEXT_COLOR: "#fd0",
	PROGRESS_PENDING_BAR: "#edf0f2",
	TIKTOK_BTN_BG_COLOR: "#121212",
	YELLOW_COLOR: "#ffec9c",
};
